import LanguageFieldTitleLink from "./language-title-link-field";
import LanguageSelectField    from "./language-select-field";


const LanguageFields = {
    TitleLink : LanguageFieldTitleLink,
    Select    : LanguageSelectField
}

export default LanguageFields;